import { Outlet, Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "./lib/auth";
import { Logo } from "./components/Logo";
import { cn } from "./lib/cn";

export function App() {
  const { user, loading, refresh, logout } = useAuth();
  const loc = useLocation();

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <div className="relative isolate min-h-full">
      <header className="sticky top-0 z-30 border-b border-white/[0.06] bg-ink-950/70 backdrop-blur-xl">
        <div className="mx-auto flex h-14 max-w-7xl items-center justify-between px-4 sm:px-6">
          <Link to="/" className="flex items-center gap-2.5 text-white/90 hover:text-white">
            <Logo className="h-6 w-6" />
            <span className="text-[15px] font-semibold tracking-tight">Motion</span>
            <span className="hidden text-xs font-normal text-white/40 sm:inline">/ AI Logo Animator</span>
          </Link>
          <nav className="flex items-center gap-1">
            <NavLink to="/templates" current={loc.pathname}>Templates</NavLink>
            {user && <NavLink to="/dashboard" current={loc.pathname}>Dashboard</NavLink>}
            {!loading && !user && (
              <>
                <Link to="/login" className="btn-quiet">Log in</Link>
                <Link to="/signup" className="btn-primary">Get started</Link>
              </>
            )}
            {user && (
              <div className="ml-2 flex items-center gap-2">
                <Link to="/editor/new" className="btn-primary">New animation</Link>
                <button onClick={() => logout()} className="btn-quiet" title={user.email}>Log out</button>
              </div>
            )}
          </nav>
        </div>
      </header>
      <main className="relative z-10">
        <Outlet />
      </main>
      <footer className="relative z-10 border-t border-white/[0.06] py-8 text-center text-xs text-white/30">
        Built on Cloudflare Workers · D1 · R2 · Workers AI. Made for shipping logos that move.
      </footer>
    </div>
  );
}

function NavLink({ to, current, children }: { to: string; current: string; children: React.ReactNode }) {
  const active = current === to;
  return (
    <Link
      to={to}
      className={cn(
        "rounded-lg px-3 py-1.5 text-sm transition-colors",
        active ? "bg-white/[0.06] text-white" : "text-white/60 hover:bg-white/[0.04] hover:text-white"
      )}
    >
      {children}
    </Link>
  );
}
